import axiosClient from "./axiosClient";

export function registerUser(userDetails) {
  return axiosClient
    .post("/licensing/validate_license/", userDetails)
    .then((res) => res.data);
}

export function loginUser(credentials) {
  return axiosClient
    .post("/licensing/login_user/", credentials)
    .then((res) => res.data);
}

export function loginAdmin(admin_credentials) {
  return axiosClient
    .post("/licensing/login_admin/", admin_credentials)
    .then((res) => res.data);
}
